import { render, staticRenderFns } from "./AfterFindPositionPopup.vue?vue&type=template&id=b2cdeca8&scoped=true&"
import script from "./AfterFindPositionPopup.vue?vue&type=script&lang=js&"
export * from "./AfterFindPositionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cdeca8",
  null
  
)

export default component.exports